var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"main-container",attrs:{"id":"app"}},[_c('router-view')],1),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mask),expression:"mask"}],staticClass:"modal-mask",staticStyle:{"z-index":"10000"},style:({zIndex: _vm.maskZindex})})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }